// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SKPd2 .Xi97P{align-items:center;display:inline-flex;flex-wrap:wrap;gap:.25rem .85rem}.SKPd2 .nKtzg{font-weight:700}.SKPd2 .wkPQi{align-items:center;color:var(--anchore-color-gray-600);display:inline-flex;font-size:1rem;font-weight:400;gap:.3rem}.SKPd2 .jaBLn{font-size:1.2em;line-height:1.2}.SKPd2 .zBPg7{align-items:center;display:flex;flex-wrap:wrap;gap:.75rem 1.5rem}.SKPd2 .U7NoT{display:inline-flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SKPd2`,
	"title": `Xi97P`,
	"cve": `nKtzg`,
	"dbLink": `wkPQi`,
	"dbLinkLabel": `jaBLn`,
	"metrics": `zBPg7`,
	"impactTrigger": `U7NoT`
};
module.exports = ___CSS_LOADER_EXPORT___;
